type PermissionMapping = {
    [key: string]: {
        controller: string;
        function: string;
    };
};

export const dashboardMapping: PermissionMapping = {
    'full_hierachy_level_access': { controller: 'sales_dashboard', function: 'full_hierachy_level_access' }
};